import gql from "graphql-tag";

const RULE = gql`
  query Rule($ruleId: Int!) {
    rule(ruleId: $ruleId) {
      ruleId
      name
      username
      frequency
      injectInGameFields
      baseQuery
      enabled
      videoOptions {
        types
        options {
          name
          value
        }
        feedExclusions
        feedPreference
        orderingType
        limitCount
        limitOption
        strict
        workflow
        watermark {
          filename
        }
        captions {
          language
        }
        cropRatio {
          value
        }
      }
      notifications {
        type
        destination
        message
        destinationOptions {
          value
          type
        }
      }
    }
  }
`;

const RULES = gql`
  query Rule($limit: Int, $page: Int, $allRules: Boolean) {
    rules(limit: $limit, page: $page, allRules: $allRules) {
      rules {
        ruleId
        name
        enabled
        createdAt
        updatedAt
        username
        frequency
      }
      total
    }
  }
`;

const CLIP_DETAILS = gql`
  query ClipDetails($clipId: String!) {
    clipInfo(id: $clipId) {
      id
      plays {
        playId
        clipPosition
        startOffset
        endOffset
        feedType
        playDetails {
          id
          gamePk
          videos {
            feedType
            link
            rank
            image {
              cuts {
                at2x
              }
            }
          }
        }
      }
      videos {
        url
        startOffset
        endOffset
        clipPosition
      }
      options
    }
  }
`;

const WORKFLOW_DETAILS = gql`
  query WorkflowDetails {
    workflowDetails {
      workflowName
      description
    }
  }
`;

const VALIDATE_VIDEO_CREATION_OPTIONS = gql`
  query ValidateVideoCreationOptions(
    $videoCreationSelections: VideoCreationSelectionsInput!
  ) {
    validateVideoCreationOptions(
      videoCreationSelections: $videoCreationSelections
    ) {
      ruleFrequency
      videoCreationOptions
      orderingType
      errors {
        value
        incompatibleFields
      }
    }
  }
`;

const VIDEO_CREATION_OPTIONS = gql`
  query VideoCreationOptions {
    videoCreationOptions {
      id
      name
      displayName
      description
      incompatibleOptionIds
      restrictedToRuleTypes
      orderByTypes
      optionType {
        id
        videoOptionType
        displayName
      }
    }
  }
`;

const USER_CLIPS = gql`
  query UserClips($limit: Int, $sortBy: String, $page: Int, $title: String) {
    userClips(limit: $limit, sortBy: $sortBy, page: $page, title: $title) {
      userClips {
        id
        username
        title
        width
        height
        videoUri
        thumbnailUri
        duration
        searchCategory
        createdAt
        plays {
          id
          playId
          feedType
        }
        options
      }
      total
    }
  }
`;

const USER_CUSTOM_CLIPS = gql`
  query UserCustomClips(
    $limit: Int
    $page: Int
    $sortOrder: UserCustomClipsSort
    $description: String
    $gamePk: Int
  ) {
    userCustomClips(
      limit: $limit
      page: $page
      sortOrder: $sortOrder
      description: $description
      gamePk: $gamePk
    ) {
      customClips {
        id
        gamePk
        feedType
        userId
        userName
        url
        thumbnailUri
        description
        startTime
        endTime
        assetName
      }
      total
    }
  }
`;

const ALL_CUSTOM_CLIPS = gql`
  query AllCustomClips(
    $limit: Int
    $page: Int
    $sortOrder: UserCustomClipsSort
    $description: String
    $gamePk: Int
  ) {
    allUserCustomClips(
      limit: $limit
      page: $page
      sortOrder: $sortOrder
      description: $description
      gamePk: $gamePk
    ) {
      customClips {
        id
        gamePk
        feedType
        userId
        userName
        url
        thumbnailUri
        description
        startTime
        endTime
      }
      total
    }
  }
`;

const GAME_MEDIA = gql`
  query GameMedia($gamePk: Int!, $gameDate: String) {
    gameMedia(gamePk: $gamePk, gameDate: $gameDate) {
      id
      source
      name
      feedType
      playbackUrl
      gameDate
      audioTracks {
        language
        name
        renditionName
        trackType
      }
    }
  }
`;

const ALLOWED_SPORTS = gql`
  query AllowedSports {
    allowedSports {
      id
      code
      name
      abbreviation
    }
  }
`;

export {
  CLIP_DETAILS,
  RULE,
  RULES,
  VALIDATE_VIDEO_CREATION_OPTIONS,
  WORKFLOW_DETAILS,
  VIDEO_CREATION_OPTIONS,
  USER_CLIPS,
  USER_CUSTOM_CLIPS,
  ALL_CUSTOM_CLIPS,
  GAME_MEDIA,
  ALLOWED_SPORTS
};



// WEBPACK FOOTER //
// ./src/httpClients/graphql/sporty-queries.js